import SupplierDetail from "@components/molecules/SupplierDetail";
import styled from "styled-components/native";
import { MatchSupplierDetailViewProps } from "./types";
import { Platform } from "react-native";
import { css } from "styled-components/native";
import { matchPairConatinerWidth } from "@scenes/findMatch/utils";

const MatchSupplierDetailView = ({
  itemDetail,
  otherDetail,
  currentIndex,
}: MatchSupplierDetailViewProps) => {
  return (
    <PriceDetailContainer>
      <FlexMainView>
        <MainContainerView testID="findMatch.supplierDetail.primary">
          <LeftLabelContainer keyMargin={20}>
            <SupplierDetail itemDetail={itemDetail} />
          </LeftLabelContainer>
        </MainContainerView>
        <GapView />
        <MainContainerView testID="findMatch.supplierDetail.secondary">
          <LeftLabelContainer keyMargin={20}>
            <SupplierDetail itemDetail={otherDetail?.[currentIndex]} />
          </LeftLabelContainer>
        </MainContainerView>
      </FlexMainView>
    </PriceDetailContainer>
  );
};

const PriceDetailContainer = styled.View`
  flex-direction: column;
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  ${({ theme }) => matchPairConatinerWidth(theme)}
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
`;

const LeftLabelContainer = styled.View<any>`
  margin: ${({ keyMargin }) => `10px ${keyMargin}px`};
`;

const GapView = styled.View`
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      width: 30px;
    `}
`;

export default MatchSupplierDetailView;
